import { plugin, Mode } from 'light-component';
import { useTranslation } from '../../../i18n';
import { Thumbnail } from '../../component';
import { WidgetType } from '../types';
import { RadioBoxInputMode } from './input';
import { RadioBoxDesignMode } from './design';
import { RadioBoxViewMode } from './view';
import type { ReactElement } from 'react';
import type { RadioBoxProps } from './types';

export function RadioBox(props: RadioBoxProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='RadioBoxIcon' title={t('RadioBox')} toolTipContent={t('RadioBox')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<RadioBoxDesignMode {...props} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<RadioBoxViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<RadioBoxInputMode {...props} />);
  }

  return null;
}

RadioBox.prototype.type = WidgetType.RADIOBOX;
plugin.register({ kind: 'widget', component: RadioBox });
